module.exports = require('./helpers/bundle-url').getBundleURL('bLxZJ') + "virtual-vending-machine.c218e313.png" + "?" + Date.now();